import * as React from 'react';
import { Form, Input, EditModes, SystemDashboardLayout, Switch } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import AddProjectScoreCardVersionGroup from 'Components/ProjectScoreCardGroup/AddProjectScoreCardVersionGroup';
import ProjectScoreCardGroup from 'Components/ProjectScoreCardGroup/ProjectScoreCardGroup';
import HeaderDashboard from '../DashboardComponent/headerdashboard/HeaderDashboard';
import { useParams } from 'react-router-dom';

interface IDataModel extends IFormData {
    ScoreCardVersionId?: number,
    PrimaryKeyEncrypted?: string,
    VersionNumber?: string,
    IsCurrent?: boolean,
    RowVersion?: string
}

export default class ProjectScoreCardVersionForm extends SystemFormDetail<IDataModel>{
    data: any;
    constructor(props: any) {
        super(props);
        this.data = props.location.data
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                IsCurrent: false,
                PrimaryKeyEncrypted: (this.data && this.data.PrimaryKeyEncrypted) ? this.data.PrimaryKeyEncrypted : undefined
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {            
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    VersionNumber: data.VersionNumber,
                    IsCurrent: data.IsCurrent == true ? data.IsCurrent : false,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    render() {
        return (<>
            <div className="DashboardWrapperChild">
                <div className="contentWrapper">
                    <HeaderDashboard title="Top" tagLine="" />
                    <div className="container-fluid mt-80">
                        <div className="row">
                            <div className="col-md-12">
                                <section className="tile-wrapper row">
                                    <div className="container-fluid containerpadding row security-tile-mobile">
                                        <fieldset className="fieldsetGridAndForm">
                                            <Form
                                                label="Score Card Version"
                                                url={'ScoreCardVersions'}
                                                onLoad={this.load}
                                                showReview={false}
                                                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                                                securityObject="Top.ScoreCardVersions"
                                                schema="Top" table="ScoreCardVersions"
                                                onInitialize={this.initialize}
                                                onClear={this.initialize}
                                                onValidate={this.validate}
                                                onPrepare={this.prepare}
                                                showBack={true}
                                                onRecordUpdated={this.onRecordUpdated} >

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Input
                                                        isRequired={true}
                                                        id="VersionNumber"
                                                        name="VersionNumber"
                                                        label='Version Number'
                                                        labelClass="col-12"
                                                        componentClass="col-12"
                                                        onChange={this.handleChange}
                                                        value={this.state.formData.VersionNumber}
                                                        validator={this.validator} />
                                                </div>

                                                <div className="col-md-4 col-12 mb-2">
                                                    <Switch
                                                        label='Is Current'
                                                        validator={this.validator}
                                                        onChange={this.handleChange}
                                                        labelClass="col-12"
                                                        labelFormat='nocase'
                                                        componentClass="col-12"
                                                        name='IsCurrent'
                                                        id='IsCurrent'
                                                        value={this.state.formData.IsCurrent} />
                                                </div>
                                            </Form>

                                            {(this.data === undefined) ?
                                                null
                                                :
                                                <div>
                                                    <SystemGridAndForm label="Score Card Version Group" data={this.data.ScoreCardVersionId} form={AddProjectScoreCardVersionGroup} grid={ProjectScoreCardGroup} securityObject="Top.ScoreCardGroups" />
                                                </div>}
                                        </fieldset>
                                    </div>
                                </section>                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </>)
    }
};